import { getUnixTime } from 'date-fns';
import { utcToZonedTime, zonedTimeToUtc } from 'date-fns-tz';
import { dateFormat as formatBeijingUnixDate } from './timeHelper';

const BEIJING_TIME_ZONE = 'Asia/Shanghai';

export const formatUnixDate = (date, dateFormat = 'yyyy年M月d日') =>
  formatBeijingUnixDate(date, dateFormat);

export const formatDate = ({ date, todayText, yesterdayText }) => {
  const chineseDate = String(date).match(/^(\d{4})年(\d{1,2})月(\d{1,2})日$/);
  const dateValue = chineseDate
    ? new Date(
        Number(chineseDate[1]),
        Number(chineseDate[2]) - 1,
        Number(chineseDate[3])
      )
    : utcToZonedTime(new Date(date), BEIJING_TIME_ZONE);
  const now = utcToZonedTime(new Date(), BEIJING_TIME_ZONE);
  const yesterday = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1);
  const sameDay = (left, right) =>
    left.getFullYear() === right.getFullYear() &&
    left.getMonth() === right.getMonth() &&
    left.getDate() === right.getDate();

  if (sameDay(dateValue, now)) return todayText;
  if (sameDay(dateValue, yesterday)) return yesterdayText;
  return date;
};

export const isTimeAfter = (h1, m1, h2, m2) => {
  if (h1 < h2) {
    return false;
  }

  if (h1 === h2) {
    return m1 >= m2;
  }

  return true;
};

const getBeijingDayBoundary = (date, isEndOfDay = false) => {
  const boundary = new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    isEndOfDay ? 23 : 0,
    isEndOfDay ? 59 : 0,
    isEndOfDay ? 59 : 0,
    isEndOfDay ? 999 : 0
  );
  return getUnixTime(zonedTimeToUtc(boundary, BEIJING_TIME_ZONE));
};

/** Get the start of the selected Beijing calendar day as a UNIX timestamp. */
export const getUnixStartOfDay = date => getBeijingDayBoundary(date);

/** Get the end of the selected Beijing calendar day as a UNIX timestamp. */
export const getUnixEndOfDay = date => getBeijingDayBoundary(date, true);

export const generateRelativeTime = (value, unit, languageCode) => {
  const code = languageCode?.replace(/_/g, '-'); // Hacky fix we need to handle it from source
  const rtf = new Intl.RelativeTimeFormat(code, {
    numeric: 'auto',
  });
  return rtf.format(value, unit);
};
